import { MappableModel } from './mappable-model'

export class MembershipNumber extends MappableModel {
  public number: string
  public number_generator_id: string
  public id: string
}
